// Libraries
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router, Params }   from '@angular/router';
import { BookingComponent } from '../BookingComponent';
import * as _ from 'lodash';
import * as moment from 'moment';
import * as $ from 'jquery';

// Services
import { BookingHolidayService } from '../../../services';

import { SessionStorageService, FileService, CatalogService, LocalStorageService } from '../../../../common/modules/core/services';
//Models
import { ClassChild, Reservation, CancelReservation, BookingItem, DiscoundConfig } from '../../../models';
import { DialogModule } from 'primeng/primeng';

@Component({
    selector: 'activites-list',
    template: require('./ActivitesListComponent.html'),
    styles: [ require('./ActivitesListComponent.sass') ]
})

export class ActivitesListComponent extends BookingComponent implements OnInit {
    private children: any;
    private selectedChild: any;
    private showRemindModal: boolean;
    private countdown: string;
    private showLackInfoModal: boolean = false;
    private showWaitingModal: boolean = false;
    // Clases
    private clases: any
    private period: any = []
    private showWeekModal: boolean = false
    private showDesModal: boolean = false
    // For period select
    private weeks: any = []
    private weekSelect: any = []
    private currentSelectClassId: number
    // Booking
    private tempBooking : any = ''
    private waiting: any = ''
    private selectedClassId: any
    private booking: any = []
    private isWinterSemester: Boolean = false;
    currentSemester: any = {
        name: ''
    }
    private olderConfig: DiscoundConfig
    private siblingConfig: DiscoundConfig
    private earlyBirdConfig: DiscoundConfig
    private aisStudentConfig: DiscoundConfig
    private currentYear: any = moment().year();

    constructor(
        protected fileService: FileService,
        protected route: ActivatedRoute,
        protected router: Router,
        protected catalogService :CatalogService,
        protected services: BookingHolidayService,
        protected sessionStorageService: SessionStorageService,
        protected local: LocalStorageService,
    ){
        super(router, services, sessionStorageService);
    }

    ngOnInit() {
        this.countdown = moment(this.sessionStorageService.getData('countdown')).format('mm:ss');
        // Retrieve holiday children from session
        this.children = this.getHolidayChildren();
        // Get selected child
        this.selectedChild = this.getSelectedChild();
        // Get weeks
        this.getWeeks();
        // Get available courses
        // this.getAvailableClasses();
        // Init booking from session if have
        this.initBooking();

        this.getSemester();
        this.getDiscountConfiguration();
    }

    checkReturnerYear() {
        let yearArr: number[] = [];
        const condition = Number(this.olderConfig.condition)
        if (this.olderConfig.condition){
            for(let i=1; i<=condition; i++)
                yearArr = [...yearArr, this.currentYear - i]
            }
        // return yearArr.sort().join(' or ');
        return yearArr.sort()[0];
    }

    protected getDiscountConfiguration() {
        this.services.getDiscountConfig('sibling')
            .subscribe(
                config => {
                    this.siblingConfig = config
                }
            )
        this.services.getDiscountConfig('older')
        .subscribe(
            config => {
                this.olderConfig = config
            }
        )
        this.services.getDiscountConfig('early-bird')
            .subscribe(
                config => {
                    this.earlyBirdConfig = config;
                    this.earlyBirdConfig.condition = moment(config.condition).format('DD MMM YYYY');
                }
            )
        this.services.getDiscountConfig('ais')
        .subscribe(
            config => {
                this.aisStudentConfig = config
            }
        )
    }

    protected getSemester() { 
        this.catalogService.getSemesters()
            .subscribe(
                semesterList => {
                    this.currentSemester = _.find(semesterList, 'is_current');
                    if(this.currentSemester.is_current && this.currentSemester.name == 'Semester 2') { 
                        this.isWinterSemester = true;
                    }
                },
                error => {
                    console.log("Cannot get semester list from API.");
            }
        )
    }
    // Initial booking info from session
    initBooking() {
        if(this.getBooking()){
            this.booking = this.getBooking();
            // Set selected class id
            this.selectedClassId = this.booking.hol_class_id;
            
            // Set selected weeks
            this.weekSelect[this.selectedClassId] = [];
            _.forEach(this.booking.periodWeeks, (val, key) => {
                this.weekSelect[this.selectedClassId][val] = true;
            });

            //set Q&A
            if(this.getQuestionAnswer()){
                this.booking.question_answer = this.getQuestionAnswer();
            }

            // Temp booking
            this.tempBooking = this.booking.temp ? this.booking.temp : '';
            this.waiting = this.booking.waiting ? this.booking.waiting : '';

            // Set period selected
            setTimeout(() => {
                this.period[this.selectedClassId] = this.booking.period[this.selectedClassId];
            }, 100); 
        }
        else{
            //if class booking created , get 

            this.showRemindModal = true;
        }

    }

    // Retrieve all available classes for selected child by his dob
    getAvailableClasses() {
        let query = {
            "date_of_birth": this.timeDataFormat(this.selectedChild.date_of_birth, 'YYYY-MM-DD'),
            "limit": 100,
            "page": 1
        }

        // Get courses arcordingly to selected child dob
        this.services.getClasses(query).subscribe(
            result => {
                // Get clases
                this.clases = _.filter(result.data, {'status': 'opened'});
                // Default set full period
                if(this.clases && this.clases.length){
                    _.forEach(this.clases, (val, key) => {
                        this.period[val.id] = 'full';
                        this.setFullWeek(val.id);
                    })
                }
                else{
                    //if dont have class,clear answerList in session
                    this.sessionStorageService.removeData("answerList");
                }
            },
            error => {

            }
        )
    }

    // Retrieve all holiday's weeks
    getWeeks() {
        this.service.getWeeks().subscribe(
            result => {
                // Get weeks
                this.weeks = result;
                // Sort weeks
                this.weeks = _.sortBy(this.weeks, (o: any) => { return o.name; })
                this.getAvailableClasses();
            },
            error => {

            }
        )
    }

    // Calculate reservation when make change on class
    // calculateReservation(singleClass: ClassChild) {
        
    // }

    // Select another child then refresh open classes 
    changeChild() {
        let child = _.find(this.children.holStudents, {'code': this.selectedChild.code});
        this.selectedChild = child;
        // Update child id in session storage
        this.setSelectedChild(child);
    }

    // Set full week period for a class
    setFullWeek(classId: number) {
        // Check if exist week selected for class        
        if(!this.weekSelect[classId]){
            this.weekSelect[classId] = []
        }
        
        // Set all week
        _.forEach(this.weeks, (val, key) => {
            this.weekSelect[classId][val.id] = true;
        })
        
        // Update booking info if selected class
        if(classId == this.selectedClassId){
            this.onCloseWeekModal('');
        }
    }

    /**
     * Get file url based on fileId.
     * @param {string} fileId - Id of the file
     * @returns {string} file URL string
     */
    protected getFileUrl(fileId: string) {
        return this.fileService.getFile(fileId);
    }

    //Pop up modal description
    private showClassDescription(title: string, content: string) {
        let modalTitle = title;
        let modalContent = content;
        document.getElementById("descriptionModal").style.display = "block";
        document.getElementById("classDescriptionModalTitle").innerHTML = modalTitle;
        document.getElementById("classDescriptionModalBody").innerHTML = modalContent;
    }

    //Close pop-up
    closeModal() {
        document.getElementById("descriptionModal").style.display = "none";
    }

    // On open week modal
    openWeekModal(classId: number) {
        // Set current select class id
        this.currentSelectClassId = classId;
        // Check if exist week selected for class        
        if(!this.weekSelect[classId]){
            this.weekSelect[classId] = []
        }

        // Show week modal
        this.toggleWeekModal();
    }

    // Show/hide select week modal
    toggleWeekModal() {
        return this.showWeekModal = !this.showWeekModal;
    }

    // Event onAfterHide select week dialog
    // Detect change week to update booking
    onCloseWeekModal(event: any) {
        // If current class select week is the same as selected class
        if(this.currentSelectClassId == this.selectedClassId){
            let isWaiting = _.find(this.weekSelect[this.selectedClassId], (o: any) => { return o == false});
            // If week select is suitable for waiting status
            if(isWaiting === false){
                // Check if there is waiting booking reservation
                if(!this.waiting){
                    // Reserve a class
                    this.sendClassReserve(this.currentSelectClassId);
                }
                else{
                    // Update current waiting booking
                    this.updateClassReserve(this.waiting, this.selectedClassId);
                }
            }
            // If select full week (full programme)
            else{
                // Check if there is waiting booking reservation
                if(!this.tempBooking){
                    // Reserve a class
                    this.sendClassReserve(this.currentSelectClassId);
                }
                else{
                    // Update current waiting booking
                    this.updateClassReserve(this.tempBooking, this.selectedClassId);
                }
            }
        }
    }

    // Toggle class selection
    toggleSelectClass(classId: number) {
        // Check if class id is exist in temp array
        if(!this.tempBooking && !this.waiting){
            // Reserve a class
            this.sendClassReserve(classId);
        }
        // If exist
        else{
            let isWaiting = _.find(this.weekSelect[classId], (o: any) => {return o == false});
            // If week select is suitable for waiting status
            if(isWaiting === false){
                // Check if there is waiting booking reservation
                if(!this.waiting){
                    // Reserve a class
                    this.sendClassReserve(classId);
                }
                else{ 
                    // Update current waiting booking
                    this.updateClassReserve(this.waiting, classId);
                }
            }
            // If select full week (full programme)
            else{
                // Check if there is waiting booking reservation
                if(!this.tempBooking){
                    // Reserve a class
                    this.sendClassReserve(classId);
                }
                else{
                    // Update current temp booking
                    this.updateClassReserve(this.tempBooking, classId);
                }
            }
        }
    }

    // Reserve a class when select
    sendClassReserve(classId: number) {
        this.booking = {
            "name": "sample",
            "payment_method": "cash",
            "hol_class_id": classId,
            "hol_student_id": this.selectedChild.id,
            "question_answer": this.getQuestionAnswer()
        };

        this.booking.weeks = [];
        // Add weeks
        Object.keys(this.weekSelect[classId]).forEach(prop => {
            if(this.weekSelect[classId][prop]){
                this.booking.weeks.push({
                    hol_week_id: +prop,
                    excursions: []
                })
            }
        })

        // Book sample info to make a reservation
        this.service.postBooking(this.booking).subscribe(
            result => {
                // Store id to booking info
                this.booking.id = result.data.id;
                // If waiting status
                if(result.data.status){
                    if(result.data.status == 'waiting'){
                        // Add to waiting list
                        this.waiting = result.data.id;
                        // Show message
                        // this.showWaitingModal = true;
                    }
                    else{
                        // Save temp booking for full programme
                        this.tempBooking = result.data.id;
                    }
                }

                this.booking.hol_class_id = classId;
                // Toggle selected class
                this.selectedClassId = classId;
            },
            error => {

            }
        )
    }

    // Update Class reservation on re-select weeks or change class
    updateClassReserve(bookingId: string, classId: number) {
        // Renew weeks array
        this.booking.weeks = [];
        // Add weeks if checked
        Object.keys(this.weekSelect[classId]).forEach(prop => {
            if(this.weekSelect[classId][prop]){
                this.booking.weeks.push({
                    hol_week_id: +prop,
                    excursions: []
                })
            }
        })

        if(bookingId == this.waiting){
            // this.showWaitingModal = true;
        }

        // Store id to booking info
        this.booking.id = bookingId;
        this.booking.hol_class_id = classId;
        // Toggle selected class
        this.selectedClassId = classId;

        // Collect query data
        // let query = {
        //     id: bookingId,
        //     name: this.booking.name,
        //     hol_class_id: this.booking.hol_class_id,
        //     hol_student_id: this.booking.hol_student_id
        // }

        // Update booking
        // this.services.updateBooking(query).subscribe(
        //     result => {
        //         // If waiting status
        //         if(result.data.status && result.data.status == 'waiting'){
        //             // Show message
        //             this.showWaitingModal = true;
        //         }
        //     },
        //     error => {

        //     }
        // )
    }
    
    // Submit Class reservation
    submitClassReservation(studentId: number) {
        if(this.selectedClassId == '' || !this.weekSelect[this.selectedClassId] || (this.period[this.selectedClassId] == 'period' && this.weekSelect[this.selectedClassId].indexOf(true) === -1)){
            return this.showLackInfoModal = true;
        }

        // Create weeks array
        // this.booking.weeks = [];
        // Check if exist period select
        this.booking.periodWeeks = []

        // If period is full
        // if(this.period[this.selectedClassId] == 'full'){
        //     // Loop through week array
        //     _.forEach(this.weeks, (val, key) => {
        //         this.booking.periodWeeks.push(val.id)
        //     })
        // }

        // If period is not full
        // if(this.period[this.selectedClassId] == 'period'){
        //     // Loop through selected week array with key is weekId
        //     _.forEach(this.weekSelect[this.selectedClassId], (val, key) => {
        //         // If val is true we push key to booking weeks array
        //         if(val){
        //             this.booking.periodWeeks.push(key)
        //         }
        //     })
        // }

        Object.keys(this.weekSelect[this.selectedClassId]).forEach(prop => {
            if(this.weekSelect[this.selectedClassId][prop]){
                this.booking.periodWeeks.push(+prop)
            }
        })

        // Set discount
        this.booking.discount = this.children.discount;
        // Store class info
        this.booking.class = _.find(this.clases, (o:any) => {
            return o.id == this.selectedClassId;
        });

        // Store period select
        this.booking.period = this.period;
        // Save week info for later use
        this.booking.allWeek = this.weeks;
        // Survey field, don't know what is it
        // Check survey on editing
        if(!this.booking.survey){
            this.booking.survey = '';
        }
        
        // Store booking info to session
        this.booking.temp = this.tempBooking;
        this.booking.waiting = this.waiting;

        this.setBooking(this.booking);
        // Navigate to next step
         this.router.navigate([`booking/${this.isWinterSemester ? 'excursions' : 'bus' }`]) ;
         
         this.services.getChildren().subscribe(
            result => {
                // Get all children
                if(result.holStudents){
                    this.children = _.filter(result.holStudents, {'status': 'active'});
                }
        
                // Set session children to avoid re-request
                this.setHolidayChildren(result);
            },
            error => {
        
            }
        )
    }
}


// WEBPACK FOOTER //
// ./src/holiday/parent/booking/3-activites-list/ActivitesListComponent.ts